import React from 'react'
import firebase from 'firebase'
import {Route, NavLink, Switch} from 'react-router-dom'
import {writeUserData} from 'firebase-main'

import './App.css';

import Dashboard from 'pages/Dashboard'
import ItemAuction from 'pages/ItemAuction'
import Profile from 'pages/Profile'
import MyOffers from 'pages/Myoffers'

const debug = false
// console.debug('%crender', 'background: #668; color: #bada55')


/*
  var newPostKey = firebase.database().ref().child('posts').push().key;

  // Write the new post's data simultaneously in the posts list and the user's post list.
  var updates = {};
  updates['/posts/' + newPostKey] = postData;
  updates['/user-posts/' + uid + '/' + newPostKey] = postData;

  return firebase.database().ref().update(updates);


var commentsRef = firebase.database().ref('post-comments/' + postId);
commentsRef.on('child_added', function(data) {
  addCommentElement(postElement, data.key, data.val().text, data.val().author);
});
 */


export default class App extends React.Component {

    state = {
      items: {}
    }

    /**
     * The ID of the currently signed-in User. We keep track of this to detect Auth state change events that are just
     * programmatic token refresh but not a User status change.
     */
    currentUID = null

    constructor() {
      super()
      firebase.database().ref('items').once(  'value', data => this.setState({items: data.val()})  )
      firebase.database().ref('items').on(  'child_changed', data => this.setState(state => (
        {items: {...state.items, [data.key]: data.val()}}
      ))  )
      firebase.auth().onAuthStateChanged(this.onAuthStateChanged);
    }

    handleSignIn = () => {
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithPopup(provider);
    }

    handleSignOut = () => {
      firebase.auth().signOut();
    }

    /**
     * Triggers every time there is a change in the Firebase auth state (i.e. user signed-in or user signed out).
     */
    onAuthStateChanged = user => {
      // We ignore token refresh events.
      if (user && this.currentUID === user.uid) {
        return;
      }

      if (user) {
        this.currentUID = user.uid;
        // startDatabaseQueries();
        writeUserData()
      } else {
        // Set currentUID to null.
        this.currentUID = null;
      }

      this.forceUpdate()
    }

    render() {
      if (debug) console.debug('%crender app', 'background: #668; color: #bada55')

      if (!firebase.auth().currentUser) return (
        <div className="App">
        <div className="demo-layout mdl-layout mdl-js-layout mdl-layout--fixed-header">

          {/* <!-- Splash screen --> */}
          <section id="page-splash">
            <h3 className="logo">{pageHeader}</h3>
            <div>
              <button
                onClick={this.handleSignIn}
                id="sign-in-button" className="mdl-button--raised mdl-button mdl-js-button mdl-js-ripple-effect"
              ><i className="material-icons">account_circle</i> Sign in with Google</button>
            </div>
          </section>

        </div>
        </div>
      )

      return (
        <div className="App">
        <div className="demo-layout mdl-layout mdl-js-layout mdl-layout--fixed-header">

          {/* <!-- Header section containing logo and menu --> */}
          <header className="header mdl-layout__header mdl-color-text--white mdl-color--light-blue-700">

            <div className="mdl-layout__header-row titlebar">
              <h3 className="logo">{pageHeader}</h3>
              <button id="sign-out-button" className="mdl-button--raised mdl-button mdl-js-button mdl-js-ripple-effect"
                onClick={this.handleSignOut}
              ><i className="material-icons">account_circle</i> Sign out</button>
            </div>

            {/* <!-- Navigation Bar --> */}
            <div className="tab mdl-layout__header-row mdl-color--light-blue-600">
              <div className="mdl-tab">
                <MenuItem exact to='/' id="menu-exchange" icon='gavel' title='Exchange'/>
                <MenuItem to='/my-offers' icon='search' title='My offers'/>
                <MenuItem to='/settings' icon='account_box' title='My Profile'/>

                {/* <MenuItemDumb id="menu-recent" icon='new_releases' title='Recent'/>
                <MenuItemDumb id="menu-my-posts" icon='account_box' title='My posts'/>
                <MenuItemDumb id="menu-my-top-posts" icon='trending_up' title='My top posts'/> */}

                {newPostButton}
              </div>
            </div>
          </header>

          <main className="mdl-layout__content mdl-color--grey-100">

        {/* ---------------------------------------------------------------------------- */}

          <section className="mdl-grid content" style={{display: 'block'}}>
            <Switch>
              <Route exact path='/' render={() => <Dashboard items={this.state.items}/>}/>
              <Route path='/:item/:tier/:blueprint?' component={ItemAuction}/>
              <Route path='/my-offers' component={MyOffers}/>
              <Route path='/settings' component={Profile}/>
              <Route render={() => <Dashboard items={this.state.items}/>}/>
            </Switch>
          </section>

        {/* ---------------------------------------------------------------------------- */}

          {
          // {/* <!-- Show the add post form --> */}
          // {newPostForm}

          // {/* <!-- Show a list of recent posts --> */}
          // <section className="mdl-grid content" id="recent-posts-list" style={{display: 'none'}}>
          //   <div className="posts-container mdl-cell mdl-cell--12-col mdl-grid">
          //   </div>
          // </section>

          // {/* <!-- Show the list of user's posts --> */}
          // <section className="mdl-grid content" id="user-posts-list" style={{display: 'none'}}>
          //   <div className="posts-container mdl-cell mdl-cell--12-col mdl-grid">
          //   </div>
          // </section>

          // {/* <!-- Show the list of top user's posts --> */}
          // <section className="mdl-grid content" id="top-user-posts-list" style={{display: 'none'}}>
          //   <div className="posts-container mdl-cell mdl-cell--12-col mdl-grid">
          //   </div>
          // </section>
          }

          </main>
        </div>
        </div>
      )
    }
  }

// const PrivateRoute = ({ render: Component, ...rest }) => (
//   <Route {...rest} render={props => (
//     appState.isAuthenticated ? (
//       <Component {...props}/>
//     ) : (
//       <Redirect to={{
//         pathname: '/login',
//         state: { from: props.location }
//       }}/>
//     )
//   )}/>
// )

const Empty = () => <div>soon</div>

const MenuItem = ({icon, title, id, to, ...props}) => {
  return (
    <NavLink {...props} to={to || id} id={id} activeClassName='is-active' className='mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect'>
      <i className="material-icons">{icon}</i> {title}
    </NavLink>
  )
}

// const MenuItemDumb = ({active, icon, title, id}) => {
//   let className = classNames('mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect',
//     { 'is-active': active }
//   )
//   return (
//     <div id={id} className={className}>
//       <i className="material-icons">{icon}</i> {title}
//     </div>
//   )
// }


const pageHeader = 'dtx :: ΔT exchange'
const allowNewPosts = false

const newPostButton = allowNewPosts && (
  <button className="mdl-button mdl-js-button mdl-button--fab mdl-color--amber-400 mdl-shadow--4dp mdl-js-ripple-effect" id="add">
    <i className="material-icons">mode_edit</i>
  </button>
)

const newPostForm = allowNewPosts && (
  <section className="mdl-grid content" id="add-post" style={{display: 'none'}}>
    <div className="mdl-cell mdl-cell--12-col mdl-grid">

        {/* <!-- Card containing the inputs to add a new messages --> */}
        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-desktop">
          <div className="mdl-card__title mdl-color--light-blue-600 mdl-color-text--white">
            <h2 className="mdl-card__title-text">New Post</h2>
          </div>
          <div className="mdl-card__supporting-text mdl-color-text--grey-600">
            <form id="message-form" action="#">
              <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <input className="mdl-textfield__input" type="text" id="new-post-title" />
                <label className="mdl-textfield__label" htmlFor="new-post-title">Post title...</label>
              </div>
              <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <textarea className="mdl-textfield__input" rows="3" id="new-post-message"></textarea>
                <label className="mdl-textfield__label" htmlFor="new-post-message">Post message...</label>
              </div>
              <button type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect">
                Add post
              </button>
            </form>
          </div>
      </div>
    </div>
  </section>
)





// WEBPACK FOOTER //
// ./src/client/App/App.jsx